<script setup lang="ts">
import type { Product } from '~/models/Product'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { faArrowUpRightFromSquare } from '@fortawesome/duotone-regular-svg-icons'
import useAuthStore from '~/stores/auth'
import Button from '~/components/ui/Button.vue'
import AuDialog from '~/components/ui/AuDialog.vue'

const props = defineProps<{
  open: boolean
  product: Product | undefined
}>()

const emit = defineEmits(['closeDialog'])
const { t } = useI18n()
const { isTeacher } = storeToRefs(useAuthStore())

const webshopUrl = computed(() => props.product?.aunivers.webshopUrl
  ? props.product?.aunivers.webshopUrl
  : import.meta.env.VITE_WEBSHOP_SITEURL)

const description = computed(() => props.product
  ? t('search.lockedContent.relatedProduct', { product: props.product.name })
  : t('search.lockedContent.unknownProduct'))
</script>

<template>
  <AuDialog
    :open="open"
    :title="t('search.lockedContent.noAccess')"
    size="lg"
    @update:open="emit('closeDialog')"
  >
    <template #content>
      <p
        v-dompurify-html="description"
        class="mb-1"
      />
      <p v-text="isTeacher ? t('search.lockedContent.findTeacher') : t('search.lockedContent.findStudent')" />
      <div class="mt-6 flex justify-end gap-3">
        <Button
          :variant="isTeacher ? 'ghost' : 'solid'"
          @click="emit('closeDialog')"
        >
          {{ t('close') }}
        </Button>
        <Button
          v-if="isTeacher"
          :href="webshopUrl"
          target="_blank"
          @click="emit('closeDialog')"
        >
          <font-awesome-icon :icon="faArrowUpRightFromSquare" />
          {{ t('search.lockedContent.goToWebshop') }}
        </Button>
      </div>
    </template>
  </AuDialog>
</template>
